import React from "react"
import img1 from "../images/400x120-40perc-discound.png"
import blake from "../images/400x120-blake-discount.png"
import steve from "../images/400x120-steve-discount.png"
import ryan from "../images/400x120-ryan-discount.png"
import leandro from "../images/400x120-leandro-discount.png"
import koen from "../images/400x120-koen-discount.png"
import andre from "../images/400x120-andre-discount.png"
import grega from "../images/400x120-grega-discount.png"


export default function DiscountBanners({mentor}) {
  let img2;
  if (mentor == 'blake') img2 = blake;
  if (mentor == 'steve') img2 = steve;
  if (mentor == 'ryan') img2 = ryan;
  if (mentor == 'leandro') img2 = leandro;
  if (mentor == 'andre') img2 = andre;
  if (mentor == 'koen') img2 = koen;
  if (mentor == 'grega') img2 = grega;
  return (
    <div className="bg-gray-50 py-6 px-4" id="discounts">
        {/* <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:gap-24 lg:items-start"> */}
      <div className="flex flex-wrap gap-4 justify-center">
        <div>
          <a href={`#booknow`}>
            <img
              src={img1}
              alt="40perc discount"
            />
          </a>
        </div>

        <div>
          <a href={`#booknow`}>
            <img
              src={img2}
              alt="package discount"
            />
          </a>
        </div>
      </div>



      </div>
    )
}
